import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_3 = { class: "symbol-label bg-light" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_5 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_6 = { class: "pe-3 mb-5" }
const _hoisted_7 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_8 = {
  class: "symbol symbol-circle symbol-25px",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: "Nina Nilson"
}
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "overflow-auto pb-5" }
const _hoisted_11 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3 mb-5" }
const _hoisted_12 = { class: "symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px pe-2" }
const _hoisted_13 = { class: "symbol symbol-circle symbol-25px" }
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "symbol symbol-circle symbol-25px" }
const _hoisted_16 = ["alt"]
const _hoisted_17 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3 mb-0" }
const _hoisted_18 = { class: "symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px" }
const _hoisted_19 = { class: "symbol symbol-circle symbol-25px" }
const _hoisted_20 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, {
            src: "/media/icons/duotune/communication/com003.svg",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fs-5 fw-bold mb-2" }, " There are 2 new tasks for you in “AirPlus Mobile APp” project: ", -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-muted me-2 fs-7" }, "Added at 4:23 PM by", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: "/media/avatars/150-11.jpg",
              alt: _ctx.translate('FACE_OF_A_PERSON')
            }, null, 8, _hoisted_9)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            href: "#",
            class: "fs-5 text-dark text-hover-primary fw-bold w-375px min-w-200px"
          }, "Meeting with customer", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "min-w-175px pe-2" }, [
            _createElementVNode("span", { class: "badge badge-light text-muted" }, "Application Design")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: "/media/avatars/150-3.jpg",
                alt: _ctx.translate('FACE_OF_A_PERSON')
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: "/media/avatars/150-11.jpg",
                alt: _ctx.translate('FACE_OF_A_PERSON')
              }, null, 8, _hoisted_16)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
              _createElementVNode("div", { class: "symbol-label fs-8 fw-bold bg-primary text-inverse-primary" }, " A ")
            ], -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "min-w-125px pe-2" }, [
            _createElementVNode("span", { class: "badge badge-light-primary" }, "In Progress")
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("a", {
            href: "#",
            class: "btn btn-sm btn-light btn-active-light-primary"
          }, "View", -1))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[8] || (_cache[8] = _createElementVNode("a", {
            href: "#",
            class: "fs-5 text-dark text-hover-primary fw-bold w-375px min-w-200px"
          }, "Project Delivery Preparation", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "min-w-175px" }, [
            _createElementVNode("span", { class: "badge badge-light text-muted" }, "CRM System Development")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                src: "/media/avatars/150-5.jpg",
                alt: _ctx.translate('FACE_OF_A_PERSON')
              }, null, 8, _hoisted_20)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
              _createElementVNode("div", { class: "symbol-label fs-8 fw-bold bg-success text-inverse-primary" }, " B ")
            ], -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "min-w-125px" }, [
            _createElementVNode("span", { class: "badge badge-light-success" }, "Completed")
          ], -1)),
          _cache[11] || (_cache[11] = _createElementVNode("a", {
            href: "#",
            class: "btn btn-sm btn-light btn-active-light-primary"
          }, "View", -1))
        ])
      ])
    ])
  ]))
}